import React from 'react';
import { Box } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import TitleSection from 'Views/Page/Content/Modal/Components/TitleSection';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import WhatIfStepNavigatorWithSpecificLink
  from 'Views/Page/Content/Modal/Components/WhatIfStepNavigatorWithSpecificLink';
import Content from './Content';

const Layout = () => {
  const { loadModalCollectionByLink } = useModalContext();
  const { loadPageContentLink } = usePageContentContext();


  const {
    resource,
    onSubmit,
    saving,
  } = useMetaLayoutContext();

  const previousLink = resource.relationship(fr.relationships.previousLink.name)?.link('related');

  const handleSubmit = async () => {
    const resp = await onSubmit();

    // This means an error happened. so there is no point continuing
    if (!resp) {
      return resp;
    }

    const [respResource] = resp;

    if (respResource.relationship(fr.relationships.pageRefresh.name)) {
      loadPageContentLink(respResource.relationship(fr.relationships.pageRefresh.name).link('related'));
    }

    return resp;
  };

  const handleSpecificPageLink = async (link) => {
    loadModalCollectionByLink(link.url());
  };

  return (
    <React.Fragment>
      <Box>
        <TitleSection />
        <Content resource={resource} />
        <WhatIfStepNavigatorWithSpecificLink
          isLoading={saving}
          onNext={(resource.meta().canSubmit()) ? handleSubmit : null}
          onPrevious={(previousLink) ? () => {
            loadModalCollectionByLink(previousLink.url());
          } : null}
          resource={resource}
          handleSpecificPageLink={handleSpecificPageLink}
        />
      </Box>
    </React.Fragment>
  );
};

export default Layout;
